import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'antd';
import * as Utils from '../../common/utils';
import * as REQUEST from "../../common/request";
import './index.less';

const ChatInterface = () => {
    const [messages, setMessages] = useState([
        {
            text: "您好！我是朱家角的旅行智能助理，专注于提供朱家角古镇景区的旅行咨询、旅行商品导购（包括美食、酒店、特产和商品推荐）以及解答与旅行相关的问题。如果您有关于朱家角的旅游景点、特色美食、酒店选择、特产购物或活动推荐方面的问题，欢迎随时向我提问。对于其他非旅行范畴的疑问，建议您咨询其他专业客服。期待能帮助您规划一次愉快的朱家角之旅！",
            sender: 'bot'
        }
    ]);
    // 用于绑定输入框内容
    const [inputValue, setInputValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        Utils.setPageTitle('AI助理');
    }, [messages]);

    const handleSubmit = async (e) => {
        console.log('-----ok------', inputValue);
        if (!inputValue.trim()) return;
        const userMessage = { text: inputValue, sender: 'user' };
        setMessages(prev => [...prev, userMessage]);
        setInputValue('');
        setIsLoading(true);

        try {
            const aiResponse = await getAIResponse(inputValue);
            console.log(messages);
            setMessages(prev => [...prev, { text: aiResponse, sender: 'ai' }]);
        } catch (error) {
            setMessages(prev => [...prev, { text: "抱歉，获取回答时出现问题，请稍后再试。如有疑问，请拨打旅游咨询热线：021-59240077", sender: 'ai' }]);
        } finally {
            setIsLoading(false);
        }
    };

    // Mock function to simulate API call
    const getAIResponse = async (question) => {
        //请求后端接口
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/h5ai/getAnswer',
            data: { question }
        });
        if (!result) return;
        return result.data ? result.data : "抱歉，获取回答时出现问题，请稍后再试。如有疑问，请拨打旅游咨询热线：021-59240077";

    };
    return (
        <div className="chat-container">
            <div className="chat-messages">
                {messages.map((message, index) => (
                    <div key={index} className={`message ${message.sender}`}>
                        <div className="message-content">
                            {message.text.split('\n').map((paragraph, i) => (
                                <p key={i}>{paragraph}</p>
                            ))}
                        </div>
                    </div>
                ))}
                {isLoading && (
                    <div className="message ai">
                        <div className="message-content">
                            <div className="typing-indicator">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="bottom-bar">
                <div className="contact-info">
                    <button className="contact-btn" onClick={() => {
                        setTimeout(function () {
                            window.open(`${'tel:02159240077'}`);
                        }, 100);
                    }}>景区联系方式</button>
                </div>
                <div className="input-area">
                    <input
                        type="text"
                        placeholder="有什么需要问我的么？"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
                        className="chat-input"
                    />
                    <Button type='primary' onClick={handleSubmit}>发送</Button>
                </div>
            </div>
        </div>
    );
};

export default ChatInterface;